import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacySk4() {
  return (
    <div>
      <Heading
        type="h3"
        title={
          <>
            {`IV.`}
            <br />
            {`Cena služieb a platobné podmienky`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Používateľ je povinný hradiť za službu cenu (úplatu) podľa aktuálneho cenníka poskytovateľa platného pri objednaní služby. Aktuálny cenník je k dispozícii pri jednotlivej službe príslušného lektora. Ceny sú uvedené v Eur. Poskytovateľ nie je platiteľom DPH.`}</li>
            <li>{`Používateľ berie na vedomie, že úplata za služby sa hradí prostredníctvom platobnej brány spoločnosti GOPAY s.r.o., ktorá poskytuje zabezpečenú technológiu prijímania platobných kariet a online bankových prevodov podľa medzinárodného bezpečnostného štandardu PCI-DSS Level 1. Viac info na https://www.gopay.com/sk/.`}</li>
            <li>{`Poskytovateľ je oprávnený cenník zmeniť, a to zverejnením nového cenníka. Zmena ceny sa nedotýka už bežiacich zmlúv uzatvorených na dohodnuté obdobie.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={4} className={sList}>
            <li>{`V prípade voľby automatickej úhrady služby na dobu neurčitú (t. j. strhávanie úplaty z bankovej karty používateľa či jeho účtu, pokiaľ to zvolený systém úhrady umožňuje) vyslovuje používateľ objednávkou súhlas s tým, aby bola poskytovateľom alebo prevádzkovateľom príslušného platobného systému uskutočnená automatická platba dohodnutých súm v príslušnom intervale bez potreby osobnej autorizácie platby zo strany používateľa. Platby platobnou kartou budú prebiehať v zjednodušenej forme, tj. bez nutnosti zadávať zakaždým všetky údaje o platobnej karte. Na základe údajov o platobnej karte poskytnutých zákazníkom PayU bude vygenerovaný Poskytovateľovi Token (identifikátor virtuálnej karty) pre opakujúce sa platby. Frekvencia automatického platenia zodpovedá zvolenému platobnému obdobiu, pričom úhrada na nasledujúce obdobie bude odoslaná vždy na konci aktuálneho obdobia. Používateľ je oprávnený zmeniť spôsob platenia vo svojom používateľskom rozhraní.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacySk4;
